// eslint-disable-next-line
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const handleResponse = async (res: Response) => {
  if (!res.ok) {
    const errorData = await res.json();
    const error = new Error('Request failed') as Error & {
      data: any;
      status: number;
    };
    error.status = res.status;
    error.data = errorData;
    throw error;
  }

  return res.json();
};

export const httpClient = {
  POST: async <TBody, TResponse>(
    url: string,
    body: TBody,
  ): Promise<TResponse> => {
    return fetch(`${BASE_URL}${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }).then(handleResponse);
  },
  GET: async <TQuery, TResponse>(
    url: string,
    query?: TQuery,
  ): Promise<TResponse> => {
    const queryParams = query
      ? `?${new URLSearchParams(query).toString()}`
      : '';
    return fetch(`${BASE_URL}${url}${queryParams}`).then(handleResponse);
  },
};
